import CurrentStepActions from '@store/currentStep/constants';
import FormCompletionActions from '@store/formCompletion/constants';
import { IRootState } from '@store/root/rootState';
import { StepAction } from 'Components/buttons/stepButton';
import { TrackPayload, TrackingVendor } from '../types';

/*
 * Default data passed with every tracking event
 */
export const getDefaultData = (reduxState: IRootState) => {
  // Add default tracking data here (example: from redux or apollo cache) //

  const s = reduxState?.analyticsManager?.userIdentifier ?? {};
  // eslint-disable-next-line camelcase
  const { institution_id, institution_name, location_id, location_name } = s;
  return { institution_id, institution_name, location_id, location_name };
};

/*
 * Get data and tracking vendor for each Event of Track redux action.
 *
 * Add switch cases in this method for additional Events of Track redux action we want to handle.
 */
export const getDataAndTrackerForTrackEvent = (
  trackPayload: TrackPayload,
  reduxState: IRootState
): [any, TrackingVendor] => {
  const trackPayloadData = trackPayload.params ?? {};
  const tracker = trackPayload.vendor || 'all';
  switch (trackPayload.event) {
    case `FILTER_EVENT`: {
      // Example placeholder case. We can delete this when we have actual tracking events.
      const withFilterData = {
        ...trackPayloadData,
        filters: {
          // @ts-ignore
          ...reduxState.filter,
        },
      };
      return [withFilterData, tracker];
    }
    default:
      return [trackPayloadData, tracker];
  }
};

export type ActionTrackData = [string, any, TrackingVendor];
/*
 * Get data and tracking vendor for any Redux action we want to track.
 * It returns null by default to mark the action as not to be tracked.
 *
 * Add switch cases in this method for additional Actions we want to track.
 */
export const getDataAndTrackerForAction = (
  action: any,
  reduxState: IRootState
): ActionTrackData | ActionTrackData[] | null => {
  switch (action.type) {
    case CurrentStepActions.SET_CURRENT_STEP: {
      const stepAction = action?.data?.stepAction as StepAction | undefined;
      const method =
        stepAction === 'key_pressed'
          ? 'Enter key pressed'
          : 'Next button clicked';
      const data = {
        method,
        page_num: reduxState.currentStep + 1, // page_num start at 1 for first page
      };
      return ['CIF_Page_Progression', data, 'gainsight'];
    }
    case FormCompletionActions.SET_FORM_COMPLETION: {
      if (action.data.completed) {
        const stepAction = action?.data?.stepAction as StepAction | undefined;
        const method =
          stepAction === 'key_pressed'
            ? 'Enter key pressed'
            : 'Done button clicked';
        const pageProgressionData = {
          method,
          page_num: reduxState.currentStep + 1, // page_num start at 1 for first page
        };

        const formCompletedData = {
          form_type: 'CIF',
        };
        return [
          ['CIF_Page_Progression', pageProgressionData, 'gainsight'],
          ['Client_Reg_Form_Completed', formCompletedData, 'gainsight'],
        ];
      }
      return null;
    }
    default: {
      return null;
    }
  }
};
try {
    // @ts-ignore
    getDefaultData.displayName = "getDefaultData";
    // @ts-ignore
    getDefaultData.__docgenInfo = { "description": "", "displayName": "getDefaultData", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/analyticsManager/tracking/prepareTrackData.ts#getDefaultData"] = { docgenInfo: getDefaultData.__docgenInfo, name: "getDefaultData", path: "src/analyticsManager/tracking/prepareTrackData.ts#getDefaultData" };
}
catch (__react_docgen_typescript_loader_error) { }